export enum BrowseScope {Presets, Samples, Soundfonts}